import React, { useRef, useState } from 'react'
import { Flex, PrimaryButton, Card } from '@workday/canvas-kit-react'
import { plusIcon } from '@workday/canvas-system-icons-web'
import EditIncidentPostForm from './EditIncidentPostForm'
import { PrimaryButtonColors } from '../../components/CanvasThemes'
import { IncidentPostData } from '../../models/IncidentPostData'

export interface NewIncidentPostCardProps {
  incidentID: string
  onSubmit: (incidentPost: IncidentPostData, callback: (success: boolean) => void) => void
}

const NewIncidentPostCard = ({ incidentID, onSubmit }: NewIncidentPostCardProps) => {
  const ref = useRef<HTMLInputElement>(null)
  const [editing, setEditing] = useState(false)
  const [incidentPost, setIncidentPost] = useState<IncidentPostData>({
    incidentID: incidentID,
    message: '',
    attachments: [],
    imagesToAdd: []
  })

  const resetForm = () => {
    setIncidentPost({
      incidentID: incidentID,
      message: '',
      attachments: [],
      imagesToAdd: []
    })
    if (ref.current) {
      ref.current.value = ''
    }
  }

  return editing ? (
    <Card>
      <Card.Heading>New Post</Card.Heading>
      <EditIncidentPostForm
        incidentPost={incidentPost}
        onCancel={() => setEditing(false)}
        onSubmit={(station, callback) => {
          onSubmit(station, success => {
            callback(success)
            if (success) {
              setEditing(false)
            }
          })
        }}
      />
    </Card>
  ) : (
    <Flex>
      <PrimaryButton
        icon={plusIcon}
        colors={PrimaryButtonColors}
        onClick={() => {
          resetForm()
          setEditing(true)
        }}
      >
        New Post
      </PrimaryButton>
    </Flex>
  )
}

export default NewIncidentPostCard
